<template>
  <div v-if="isExpress != 'hide'">
    <!--  ZOZO标签除外-->
    <div v-if="printTagData.type != 'ZOZO'" class="tabBox">
      <!-- 一维码 -->
      <div class="tiaoxingma" :class="{ EN13: printTagData.code_type == 'EN13', EN8: printTagData.code_type == 'EN8' }">
        <canvas id="express_no" />
      </div>
      <div class="head" v-if="printTagData.code_type != 'EN13' && printTagData.code_type != 'EN8'">
        {{ printTagData.no }}
      </div>
      <!-- Stockcrew 仓库标签在标签编号下方展示商品编码 -->
      <div v-if="printTagData.type === 'STOCKCREW倉庫'" class="text">
        {{ printTagData.goods_no }}
      </div>
      <div class="text" :class="{ special: userId == '15401' }">{{
        printTagData.text_line_one }}
      </div>
      <div class="text">{{ printTagData.text_line_two }}</div>
      <div class="text">{{ printTagData.text_line_three }}</div>
      <div class="text">{{ printTagData.text_line_four }}</div>
    </div>
    <!-- ZOZO标签 -->
    <div v-else class="zozo">
      <h6>{{ printTagData.text_line_one }}</h6>
      <p> {{ printTagData.no }}</p>
      <p> {{ printTagData.text_line_two }}</p>
      <div class="tiaoxingma">
        <canvas id="express_no" />
      </div>
      <p>{{ printTagData.text_line_three }}</p>
      <p style="margin-bottom:0">{{ printTagData.text_line_four }}</p>
    </div>
  </div>
  <!-- 纯文本 -->
  <div class="tabBox" v-else>
    <div class="head fontB" style="font-size: 75px;">
      <div>
        {{ printTagData.no }}
        <p> {{ printTagData.text_line_four }}</p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    printTagData: { type: Object },
    isExpress: { type: String },

  },
  data() {
    return {
      userId: this.$route.query.porder_sn ? this.$route.query.porder_sn.split('-')[1] : ''
    };
  },
  mounted() {
    if (this.isExpress != 'hide') {
      if (this.printTagData.code_type == 'EN13') {
        this.getJsBarcodeEN13("#express_no", this.printTagData.no);
      } else if (this.printTagData.code_type == 'EN8') {
        this.getJsBarcodeEN8("#express_no", this.printTagData.no);
      } else if (this.printTagData.code_type == 'CODE39') {
        this.getJsBarcodeCODE39("#express_no", this.printTagData.no);
      } else {
        this.getJsBarcode("#express_no", this.printTagData.no);
      }
    }
  },
  methods: {
    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {
        format: 'CODE128', //选择要使用的条形码类型
        displayValue: true,
        height: 160,
        margin: 0,
        width: 12,
        displayValue: false,
        fontSize: 20,//设置文本的大小
        fontWeight: 700,//设置文本的大小
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },
    // 一维码
    getJsBarcodeEN8(selector, data) {
      JsBarcode(selector, data, {
        format: 'EAN8', //选择要使用的条形码类型
        displayValue: true,
        margin: 10,
        width: 6,
        fontSize: 40,//设置文本的大小
        fontWeight: 'bold',//设置文本的大小
        lineColor: "#000000",//设置条和文本的颜色。
        fontOptions: 'bold',
      });
      this.$forceUpdate();
    },
    // 一维码
    getJsBarcodeEN13(selector, data) {
      JsBarcode(selector, data, {
        format: 'EAN13', //选择要使用的条形码类型
        displayValue: true,
        margin: 10,
        width: 6,
        fontSize: 40,//设置文本的大小
        fontWeight: 'bold',//设置文本的大小
        lineColor: "#000000",//设置条和文本的颜色。
        fontOptions: 'bold',
      });
      this.$forceUpdate();
    },
    // 一维码CODE39
    getJsBarcodeCODE39(selector, data) {
      JsBarcode(selector, data, {
        displayValue: true,
        height: 240,
        width: 6,
        margin: 2,
        fontSize: 0,
        displayValue: false,
        format: 'CODE39', //选择要使用的条形码类型
        lineColor: "#000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },
  }
}
</script>
<style lang='scss' scoped>
.tabBox {
  width: 600px;
  padding: 50px 70px 10px;

  #express_no {
    height: 160px !important;
    margin: 0 30px;
  }

  /deep/.isNeedRemove {
    height: 140px !important;
  }

  .tiaoxingma {
    max-height: 140px !important;
  }

  .EN13 {
    margin-top: 0;
    max-height: 280px !important;

    /deep/.isNeedRemove {
      height: 280px !important;
      // width: 100%;
    }

    ;
  }

  .EN8 {
    margin-top: 0;
    max-height: 300px !important;

    /deep/.isNeedRemove {
      height: 280px !important;
      // width: 100%;
    }

  }

  .head {
    font-size: 38px;
    margin: 5px 0;
    font-weight: 400;
    color: #000;
    text-align: center;
  }

  .text {
    font-size: 23px;
    color: #000;
    margin-top: 10px 0;
    width: 100%;
    // word-break: break-all;
    white-space: nowrap
  }

  .special {
    font-size: 46px;
    text-align: center;
  }

  .fontB {
    height: 600px;
    margin-top: 80px;
    font-size: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    word-break: break-all;

    p {
      margin-top: 30px;
      font-size: 68px;
      font-weight: 500;
    }
  }


}

.zozo {
  width: 640px;
  padding: 30px 40px;

  h6 {
    font-size: 35px;
    margin-bottom: 10px;
    height: 70px;
    line-height: 35px;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  p {
    margin-bottom: 5px;
    font-size: 30px;
  }

  .tiaoxingma {
    max-height: 116px !important;
    margin: 10px 0;
  }

  /deep/.isNeedRemove {
    height: 116px !important;
  }
}
</style>
